import {TopNavigation} from '@epg/epg-components'; // eslint-disable-line no-unused-vars
import '../locale-dd';
import '../notification-bell';
import '../role-toggle';
import {userTypes} from '@modules/constants-enumerate';

const orgGroupSelect = (ctx, html) => {
  if (ctx.userType === userTypes.PARENT) {
    return;
  }
  let href = null;

  const tiers = Object.keys(ctx.myGroups).map((level) => {
    if (parseInt(level, 10) <= parseInt(ctx.myLevel, 10)) return '';

    href = (!href) ? '/org-group/' + ctx.myGroups[level].level + '/' : href;
    return html`
      <a
        class="nav-dropdown-item"
        id="org-level-${ctx.myGroups[level].level}"
        data-bi-id="nav_link_to_level_${ctx.myGroups[level].level}"
        href="/org-group/${ctx.myGroups[level].level}/"
        track-url-partial>
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.85 21.956h-6.963v.334h7.87v.716H.243v-.716h7.631v-.357h-6.7a.367.367 0 0 1-.358-.358V9.746c0-.19.166-.357.357-.357h6.725V8.173s.024-.024.024-.048c0-.012.006-.018.012-.024.006-.006.012-.012.012-.024 0-.008.003-.013.005-.018.006-.011.01-.022-.005-.053.012 0 .018-.006.024-.012.006-.006.012-.012.024-.012h.023l.024-.024L11.69 5.93a.325.325 0 0 1 .358 0l3.648 2.027c.12.071.191.19.191.31v1.145h6.964c.19 0 .357.167.357.357V21.6c0 .19-.167.357-.357.357zm-14.26-.358v.716h6.582v-.716c0-.19.167-.357.358-.357h6.963V10.128H15.53a.367.367 0 0 1-.358-.358V8.482L11.88 6.646l-3.29 1.836V9.77c0 .191-.168.358-.359.358h-6.7V21.24h6.7c.191 0 .358.167.358.357z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.08 7.529v.834l-5.2-2.885-5.246 2.91v-.836l4.913-2.742c-.024-.024-.024-.072-.024-.12l-.024-3.338c0-.19.12-.334.286-.358H15.1c.19 0 .358.167.358.358v1.932c0 .19-.167.357-.358.357h-2.862v1.05c0 .047 0 .071-.024.119zm-2.361-5.82h-2.504v1.217h2.504ZM2.485 10.843h1.98c.19 0 .357.143.357.358v2.98c0 .192-.166.359-.357.359h-1.98a.367.367 0 0 1-.357-.358V11.2c0-.19.167-.358.357-.358zm.357 2.98h1.264v-2.265H2.842ZM6.015 10.843h1.979c.19 0 .358.143.358.358v2.98c0 .192-.167.359-.358.359h-1.98a.367.367 0 0 1-.357-.358V11.2c0-.19.167-.358.358-.358zm.357 2.98h1.264v-2.265H6.372ZM2.485 15.088h1.98c.19 0 .357.167.357.358v2.98c0 .192-.166.359-.357.359h-1.98a.367.367 0 0 1-.357-.358v-2.981c0-.19.167-.358.357-.358zm.357 2.981h1.264v-2.266H2.842ZM6.015 15.088h1.979c.19 0 .358.167.358.358v2.98c0 .192-.167.359-.358.359h-1.98a.367.367 0 0 1-.357-.358v-2.981c0-.19.167-.358.358-.358zm.357 2.981h1.264v-2.266H6.372ZM17.986 14.54h-1.98a.351.351 0 0 1-.357-.358V11.2c0-.19.166-.358.357-.358h1.98c.19 0 .357.167.357.358v2.98c0 .192-.167.359-.357.359zm-.358-2.982h-1.264v2.266h1.264zM21.516 14.54h-1.98a.367.367 0 0 1-.357-.358V11.2c0-.19.167-.358.357-.358h1.98c.19 0 .357.167.357.358v2.98c0 .192-.167.359-.357.359zm-.358-2.982h-1.264v2.266h1.264zM17.986 18.785h-1.98a.351.351 0 0 1-.357-.358v-2.981c0-.19.166-.358.357-.358h1.98c.19 0 .357.167.357.358v2.98c0 .192-.167.359-.357.359zm-.358-2.982h-1.264v2.266h1.264zM21.516 18.785h-1.98a.367.367 0 0 1-.357-.358v-2.981c0-.19.167-.358.357-.358h1.98c.19 0 .357.167.357.358v2.98c0 .192-.167.359-.357.359zm-.358-2.982h-1.264v2.266h1.264z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.568 10.462A2.443 2.443 0 0 1 12 8.029a2.443 2.443 0 0 1 2.432 2.433A2.443 2.443 0 0 1 12 12.894a2.443 2.443 0 0 1-2.432-2.432zm.714 0A1.71 1.71 0 0 0 12 12.179a1.71 1.71 0 0 0 1.717-1.717A1.71 1.71 0 0 0 12 8.745a1.71 1.71 0 0 0-1.717 1.717z"/><path d="M12 9.08a.367.367 0 0 0-.358.357v.668h-.668a.367.367 0 0 0-.357.357c0 .191.166.358.357.358H12c.19 0 .357-.167.357-.358V9.437A.367.367 0 0 0 12 9.079z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.758 17.569A2.24 2.24 0 0 1 12 15.327a2.239 2.239 0 0 1 2.242 2.242v4.03c0 .19-.167.358-.358.358h-3.768a.367.367 0 0 1-.358-.358zm.716 3.672h3.052V17.57c0-.835-.691-1.526-1.526-1.526-.835 0-1.526.691-1.526 1.526z"/></g></svg>
          <span style="margin-left:6px;">${ctx.myGroups[level].label}</span>
        </a>
    `;
  });

  if (!href) {
    const levels = [0, 1, 2]; // Classes, Teachers, Students

    levels.forEach((value, key) => {
      if (ctx.menuItems[value]?.show) {
        href = ctx.menuItems[value]?.href;
        return;
      }
    });
  }

  return html`<div slot="org-tier-links">${tiers}</div>`;
};

export default (ctx, html) => ctx.loggedIn ? html`
<top-navigation
  firstproduct=${ctx.products[0]}
  .atclasslevel=${ctx.atClassLevel}
  .products=${ctx.products}
  .groups=${ctx.myGroups}
  .isloggedin=${ctx.loggedIn}
  usertype=${ctx.userType}
  .stats_path=${ctx.statsPath}
  .settings="${ctx.settings}"
  .is_root_admin="${ctx.isRootAdmin}"
  @openReportDownloadModal=${ctx.openReportDownloadModal}
>
  ${orgGroupSelect(ctx, html)}
</top-navigation>
` : '';
